"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addGlobalStyleTag = addGlobalStyleTag;
exports.removeGlobalStyleTag = removeGlobalStyleTag;

/**
 * Be careful when/where you use these functions as you could override
 * global styles in an application if you're not careful
 */
function addGlobalStyleTag() {
  var _document$head;

  var hasStyleTag = document.querySelector('style[data-global-overrides="true"]') !== null;
  if (hasStyleTag) return;
  var styleTag = document.createElement('style');
  styleTag.dataset.globalOverrides = 'true';
  styleTag.innerText = '*,::after,::before{box-sizing:border-box}button:active{transform:scale(.99)}img{max-width:100%}';
  var firstChild = (_document$head = document.head) === null || _document$head === void 0 ? void 0 : _document$head.firstElementChild;

  if (firstChild) {
    document.head.insertBefore(styleTag, firstChild);
  } else {
    document.head.append(styleTag);
  }
}

function removeGlobalStyleTag() {
  var styleTag = document.querySelector('style[data-global-overrides="true"]');

  if (styleTag !== null) {
    var parent = styleTag.parentElement;
    parent === null || parent === void 0 ? void 0 : parent.removeChild(styleTag);
  }
}